export default function TeamCard({ data: { index, title, content} }) {
  return (
    <div className='flex flex-col  w-full lg:w-[45%] text-center' >
      <img
        className='rounded-[12px] lg:rounded-[28px] aspect-[560/340]'
        src={`${process.env.REACT_APP_STATIC_URL}/images/About/Team${index}_Image.jpg`}
        alt={title}
      />
      <div className='
        mt-[28px] lg:mt-[40px]
        text-heading2 lg:text-title3 text-label-400 font-bold'
      >
        {title}
      </div>
      <div className='mt-[16px] lg:mt-[20px] text-body1 lg:text-heading2 text-label-100'>
        {content?.split('\n').map((item, idx) => <p key={idx}>{item}</p>)}
      </div>
    </div>
  )
}